import { create } from 'zustand';
import { Project } from '@/lib/api';

export interface ProjectDraft {
  goal: string;
  title: string;
  file: File | null;
  budget: string;
  flexibility: "very_flexible" | "flexible_with_limits" | "selective";
  flexibilityDetails: string;
  productionDate: string;
  postProductionDate: string;
  releaseDate: string;
}

const initialDraft: ProjectDraft = {
  goal: "brand_partners",
  title: "",
  file: null,
  budget: "",
  flexibility: "flexible_with_limits",
  flexibilityDetails: "",
  productionDate: "",
  postProductionDate: "",
  releaseDate: "",
};

interface ProjectState {
  project: Project | null;
  draft: ProjectDraft;
  setProject: (project: Project | null) => void;
  updateDraft: (draft: Partial<ProjectDraft>) => void;
  resetDraft: () => void;
}

export const useProjectStore = create<ProjectState>((set) => ({
  project: null,
  draft: initialDraft,
  setProject: (project) => set({ project }),
  updateDraft: (updates) => set((state) => ({ draft: { ...state.draft, ...updates } })),
  resetDraft: () => set({ draft: initialDraft }),
}));